import { localizationService } from '@shared-services/localization-service';

export const getConfirmationString = (key: string) => {
    return localizationService.str(
        `ui.runtimessr.calbooking.confirmation.success.${key}`
    );
};

export const str = localizationService.str;

export const bookingStrings = {
    confirmation: {
        preview: {
            title: 'ui.runtimessr.calbooking.confirmation.preview.title',
            note: 'ui.runtimessr.calbooking.confirmation.preview.note',
        },
        dryRun: {
            title: 'ui.runtimessr.calbooking.confirmation.dryRun.title',
            note: 'ui.runtimessr.calbooking.confirmation.dryRun.note',
        },
        cancel: {
            title: 'ui.runtimessr.calbooking.cancelBooking.title',
            reason: 'ui.runtimessr.calbooking.cancelBooking.reason',
            cancelling: 'ui.runtimessr.calbooking.cancelBooking.cancelling',
            cancelButton: 'ui.runtimessr.calbooking.cancelBooking.cancelButton',
            placeholder:
                'ui.runtimessr.calbooking.cancelBooking.cancelling.placeholder',
        },
        reschedule: {
            title: 'ui.runtimessr.calbooking.reschedule.booking',
        },
        success: {
            reschedule:
                'ui.runtimessr.calbooking.confirmation.success.reschedule',
            who: 'ui.runtimessr.calbooking.confirmation.success.who',
            or: 'ui.runtimessr.calbooking.confirmation.success.or',
            back: 'ui.runtimessr.calbooking.confirmation.success.back',
            title: 'ui.runtimessr.calbooking.confirmation.success.title',
            cancel: 'ui.runtimessr.calbooking.confirmation.success.cancel',
            change: 'ui.runtimessr.calbooking.confirmation.success.change',
            video: 'ui.runtimessr.calbooking.confirmation.success.videoCallLink',
            description:
                'ui.runtimessr.calbooking.confirmation.success.description',
            when: 'ui.runtimessr.calbooking.confirmation.success.when',
            what: 'ui.runtimessr.calbooking.confirmation.success.what',
            host: 'ui.runtimessr.calbooking.confirmation.success.host',
            where: 'ui.runtimessr.calbooking.confirmation.success.where',
            notes: 'ui.runtimessr.calbooking.confirmation.success.notes',
        },
        pending: {
            title: 'ui.runtimessr.calbooking.confirmation.pending.title',
            subtitle: 'ui.runtimessr.calbooking.confirmation.pending.subtitle',
            change: 'ui.runtimessr.calbooking.confirmation.pending.change',
            reschedule:
                'ui.runtimessr.calbooking.confirmation.pending.reschedule',
            or: 'ui.runtimessr.calbooking.confirmation.pending.or',
            cancel: 'ui.runtimessr.calbooking.confirmation.pending.cancel',
        },
    },
};
